import Firebase from 'firebase';
import config from './firebase_config';

export const firebaseApp =  Firebase.initializeApp(config);
export const db = firebaseApp.database();
export const auth = firebaseApp.auth();
export const storage = firebaseApp.storage();



// WEBPACK FOOTER //
// ./src/store/firebase.js